module.exports = __webpack_public_path__ + "img/good.6d4d720d.png";